import React, { useState, useEffect, useRef } from "react";
import { ChevronDown } from "lucide-react";
import "./TimeDropdown.scss"; // Ensure SCSS is correctly linked

const TimeDropdown = ({
  startTime,
  handleStartTimeChange,
  availableSlots,
  fetchAvailableSlots,
  loading,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  // Toggle dropdown and fetch slots if needed
  const toggleDropdown = () => {
    if (!isOpen && availableSlots.length === 0) {
      fetchAvailableSlots(); // Fetch slots if not available
    }
    setIsOpen(!isOpen);
  };

  // Handle selecting a time
  const handleSelect = (time) => {
    handleStartTimeChange(time);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false); // Close the dropdown if the click is outside
      }
    };

    // Add event listener for clicks
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []); // Empty dependency array means this runs once on mount and cleanup on unmount

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div className="dropdown-header" onClick={toggleDropdown}>
        <span>{startTime || "Select Time"}</span>
        <span className="icon clock-icon" onClick={toggleDropdown}></span>
        <ChevronDown size={18} />
      </div>

      {isOpen && (
        <ul className="dropdown-list">
          {availableSlots.length === 0 ? (
            <li className="disabled">No Slots Available</li>
          ) : (
            availableSlots.map((slot, index) => (
              <li key={index} onClick={() => handleSelect(slot.start_time)}>
                {slot.start_time}
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  );
};

export default TimeDropdown;
